import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/set-fair-value.svg";
var SetFairValueSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  SetFairValueSolid_default as default
};
